import {
  GET_EXCHANGE_RATE
} from './mutation-types';
import Axios from 'axios';
const currency_get_rate = (context, cb) => {
  Axios.get('/rate')
    .then((response) => {
      if (response.status === 200) {
        context.commit(GET_EXCHANGE_RATE, response.data);
        cb()
      }
    });
};
export default {
  currency_get_rate,
};
